import React, { useEffect, useState } from "react";
import './mainBanner.css';
import HomeVideo from "../../assets/beachSky1.mp4";
import HomeVideo1 from "../../assets/skyScraper.webm";
import HomeVideo2 from "../../assets/skyScraper1.mp4";

export const MainBanner = () => {
  const [currentVideo, setCurrentVideo] = useState(HomeVideo1);
  const [slide, setSlide] = useState(true);

  useEffect(() => {
    const videoList = [HomeVideo, HomeVideo1, HomeVideo2];
    let videoIndex = 0;

    const interval = setInterval(() => {
      setSlide(false); // Start fading out
      setTimeout(() => {
        videoIndex = (videoIndex + 1) % videoList.length;
        setCurrentVideo(videoList[videoIndex]);
        setSlide(true); // Fade back in
      }, 400); // Ensure this timeout matches the CSS fade duration
    }, 7000); // Change video every 7 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-banner">
      <video
        className={`video-background ${slide ? "slide-in" : "slide-out"}`}
        src={currentVideo}
        autoPlay
        muted
        loop
      />
      <div className="video-overlay"></div>
      <div className="banner-content">


     



        <h1>Welcome to</h1>
        <div className="keyboard">
          <span className="key">S</span>
          <span className="key">T</span>
          <span className="key">A</span>
          <span className="key">N</span>
          <span className="key">N</span>
          <span className="key">U</span>
          <span className="key">M</span>
        </div>
        <h1>HR Consultancies</h1>
        {/* <p >Explore opportunities and connect with us. We Meet All Your HR Needs.</p> */}


        <div className="contentX">
        
        <div className="marqueeX">
          <div className="marquee_blurX" aria-hidden="true">
            <p className="marquee_textX">Explore opportunities and connect with us. We Meet All Your HR Needs.</p>
          </div>
          <div className="marquee_clearX">
            <p className="marquee_textX">Explore opportunities and connect with us. We Meet All Your HR Needs.</p>
          </div>
        </div>
      </div>

      </div>
    </div>
  );
};
